import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  toggle() {
    this.contentTarget.classList.toggle("hidden")
    this.iconTarget.innerHTML = this.contentTarget.classList.contains("hidden") ? "&#9654;" : "&#9660;"
  }
}
